
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VXETable from "vxe-table";

import { addInquirySheet } from "@/api/inquiry";
import { getRelationPaymentVoucher, removeRelation, addRelation } from "@/api/supplier-payment";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer
} from "@/api/customer";

@Component({
  name: "CreateFee",
  components: {
    ChoosePayment: () => import("./ChoosePayment.vue")
  }
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: "" }) private state: "";
  @Prop({ default: false }) private showButton: boolean;


  private supplierId = "";
  private showChoose = false;
  private form = {
    customerId: null,
    company: null
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false
    },
    {
      label: "本次使用",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;

  public tableCol1 = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "付款类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "单据剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false
    },
    {
      label: "本次使用",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: true,
      type: "inputNumber",
      precision: 2
    }
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change"
      },
      options: COMPANY_LIST
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change"
      },
      labelKey: "abbreviation",
      valueKey: "id"
    }
  ];
  private options = [];
  private value = "";

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async inputChange({ val, row, column }) {
    console.log(column.key);
    console.log(row.row);
    if (!row.row.modify) {
      this.$notify({
        title: "失败",
        message: "装箱单分配定金的关联金额不能在这里调整",
        type: "error",
        duration: 2000
      });
      this.$emit("success", false);
      return;
    }
    const { paymentRemaining, useAmount } = row.row;
    if (useAmount > paymentRemaining) {
      this.$set(row.row, "useAmount", paymentRemaining);
    }
    await this.addRelation([row.row])
  }

  //  删除
  public async handleDelete(scope) {
    if (!scope.row.modify) {
      this.$notify({
        title: "失败",
        message: "装箱单分配定金的关联金额不能在这里调整",
        type: "error",
        duration: 2000
      });
      this.$emit("success", false);
      return;
    }
    await removeRelation(scope.row.recordId);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
    this.$emit("success", false);
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  private handleAdd() {
    this.showChoose = true;
  }

  private async addRelation(list) {
    console.log(list);
    let request = list.map(item => {
      return {
        relationId: item.id,
        userAmount: item.useAmount
      };
    });
    try {
      await addRelation(this.id, request);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.value = "";
      this.$emit("success", false);
    } catch {
    }
  }
}
